import { loadDefaultJapaneseParser } from "budoux";

export function budoux() {
  const parser = loadDefaultJapaneseParser();
  //特定の指定の場合
  // const ele = document.querySelector("p.budou-this");
  // parser.applyElement(ele);

  const elems = Array.from(document.querySelectorAll(".budou-this"));
  elems.forEach((elem) => {
    parser.applyElement(elem);
  });
}
